

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import feeTable from './feeTable.vue'

@Component({
	name: 'addPlan',
	components: {
		PageLayout,
		feeTable,
	},
})
export default class addPlan extends Vue {
	@Prop()
	private data!: any

	private handleSubmit(scheme: any) {
		this.$emit('submitPlan', scheme)
		this.$emit('hidePlan')
	}

	private handleCancel() {
		this.$emit('hidePlan')
	}
}
